/*jshint esversion: 6 */
import Divider from './Divider.js';
import Navigation from './Navigation.js';
import NewsGrid from './NewsGrid.js';
import ResourcesGrid from './ResourcesGrid.js';
import Stats from './Stats.js';
import PostGrid from './PostGrid.js';
import Video from './Video.js';
import MsaComparisonMap from './MsaComparisonMap.js';
import IconCard from './IconCard.js';

const initBlocks = function($ = jQuery) {

  // ===================
  // Init Blocks
  const blocks = [
    Divider,
    Navigation,
    NewsGrid,
    ResourcesGrid,
    Stats,
    PostGrid,
    Video,
    MsaComparisonMap,
    IconCard
  ];

  blocks.forEach(block => block.init());

};

export { initBlocks };